// app/javascript/controllers/filters_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["type"];

  connect() {
    console.log("filters_controller connected");
  }

  async materialChanged(event) {
    this.resetSelect(this.typeTarget);

    const material = event.target.value;
    if (!material) return;

    const response = await fetch(
      `/options?q[material_eq]=${encodeURIComponent(material)}`,
      {
        headers: {
          Accept: "application/json"
        },
        method: "GET"
      }
    );
    const options = await response.json();
    const types = options.filter((option) => option.type === "type");
    const typeTomselect = this.typeTarget.tomselect;

    typeTomselect.clearOptions();

    types.forEach((type) => {
      typeTomselect.addOption({ value: type.name, text: type.name });
    });
    typeTomselect.refreshOptions(false);
  }

  resetSelect(element) {
    if (element.tomselect) {
      element.tomselect.clear();
    } else {
      if (element.multiple) {
        Array.from(element.options).forEach(
          (option) => (option.selected = false)
        );
      } else {
        element.selectedIndex = -1;
      }
    }
  }
}
